<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <!-- 导出按钮 -->
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`固定费用支出`)">导出</el-button>
        </el-form-item>

        <!-- 过磅单导出 -->
        <el-form-item class="endBtn" v-if="user && [1, 2, 3, 4, 5].includes(user.user_group_id)">
          <el-button class="exportBtn" type="primary" :loading="btnloading" @click="getExport">
            <i v-if="!btnloading" class="el-icon-folder"></i>
            导出
          </el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total"
      :getTotal="getTotal" :showTotal="true" :btns="btns" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" @onSortChange="onSortChange" />

    <FormDialog ref="dialog" :title="title" :labelWidth="'120px'" :form="mform" :formCtrl="mformCtrl"
      @onModalSubmit="onModalSubmit"></FormDialog>

    <FormDialog ref="dialog1" :title="'添加固定费用'" :labelWidth="'120px'" :form="mform1" :rules="mrules1"
      :formCtrl="mform1Ctrl" :viewMode="viewMode" @onChange="onModal1Change" @onModalSubmit="onModal1Submit">
    </FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';
export default {
  name: "FinanceFixedFeeList",
  mixins: [tableMixin],
  components: { Wxts },
  data() {
    return {
      baseUrl: 'fixedpay',
      breadcrumb: [
        { name: "财务管理" },
        { name: "固定费用支出表" },
      ],
      wxtsList: [
        {
          name: '如需增减字段，可在【系统设置】',
          path: '/system/fixedFee',
          pathName: '【固定费用配置】',
          tailName: '处设置。',
        },
      ],
      formInline: {},
      formCtrl: [
        {
          ...this.ctrls.month
        },
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          label: "车辆状态",
          keyName: "carstatus",
          type: "select",
          options: [],
        },
        {
          ...this.ctrls.license,
          label: "车牌号",
        },
      ],
      cols: [
        { keyName: "month", label: "月份" },
        { keyName: "license", label: "车牌号", minwidth: 100 },
        { keyName: "driver", label: "司机姓名", minwidth: '110px' },
      ],
      getTotalProperty: ['money'],
      btns: [
        {
          ...this.editBtn,
          title: '快捷录入',
          cb: (data) => {
            this.setModalData(data)
            this.showDialog()
          },
        },
        {
          title: "添加费用",
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ carid, license, driver }) => {
            this.mform1 = {
              carid,
              license,
              driver,
              fixedauth: null,
              money: null,
              addtime: this.DATE,
              voucher: null,
              remark: null,
            }
            this.getItem()
            this.showDialog('dialog1')
          },
        },
        {
          title: '费用明细',
          img: require('@/assets/img/icon_car_view.png'),
          unimg: require('@/assets/img/icon_car_view_hover.png'),
          cb: ({ id, license, carid, month }) => {
            // console.log(id)
            this.$router.push(
              `/finance/fixedFeeDetailList?id=${id}&month=${month || this.MONTH}&license=${license}&carid=${carid}`
            );
          },
        },
      ],
      getOptionUrl: 'index',
      title: '支出金额填写',
      mform: {},
      mformCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          type: "text",
          viewMode: true,
        },
      ],
      mformCtrl1: [],
      mform1: {
        fixedauth: null,
        money: null,
        addtime: null,
      },
      mrules1: {
        fixedauth: [
          { required: true, message: "请选择费用类型", trigger: "blur" },
        ],
        money: [
          { required: true, message: "请填写费用金额", trigger: "blur" },
        ],
        addtime: [
          { required: true, message: "请选择添加日期", trigger: "blur" },
        ],
      },
      mform1Ctrl: [
        {
          label: "车牌号",
          keyName: "license",
          type: "text",
          viewMode: true,
        },
        {
          label: "司机姓名",
          keyName: "driver",
          type: "text",
          viewMode: true,
        },
        {
          label: "费用类型",
          keyName: "fixedauth",
          type: "select",
          options: [],
        },
        {
          label: "费用金额",
          keyName: "money",
          err: "请填写费用金额",
          type: "number",
        },
        {
          label: "添加日期",
          keyName: "addtime",
          err: "请选择添加日期",
          type: "date",
        },
        {
          label: "费用凭证",
          keyName: "voucher",
          tips: "最多上传2张图片",
          type: "file",
          ptype: "fixedpay",
          max: 2,
        },
        {
          label: "备注",
          keyName: "remark",
          err: "请填写备注信息",
          type: "textarea",
          rows: 3,
        },
      ],
      baseParams: ['month'],
      btnloading: false,
    };
  },
  methods: {
    getExport() {
      this.btnloading = true
      let url = `fixedpay/expicture`;
      const params = {
        // userid: this.user.id,
        month: this.formInline.month,
      }

      console.log(url, params)
      this.post(url, params, (res) => {
        this.btnloading = false
        // console.log(res)
        const { msg, url } = res
        if (msg === 'success' && url) {
          console.log(url)
          var link = document.createElement('a')
          link.href = url
          // link.download = "过磅单"
          link.click()
        } else {
          this.$message({
            message: msg || '导出失败，请稍后再试！',
            type: 'error',
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },

    setOptions({ fleet, cartype, fixedauth }) {
      this.formCtrl.map(v => {
        if (v.keyName === 'fleet') {
          this.setCtrlOption(v, fleet, 'nickname')
        } else if (v.keyName === 'carstatus') {
          this.setCtrlOption(v, cartype, 'name', 'name')
        }
      })
      // 普通字段
      const arr = []
      // 固定字段
      const arr1 = []
      // 基础设置字段
      const arr2 = []
      fixedauth.map((v) => {
        const o = {
          keyName: v.enname,
          label: v.authname,
          align: 'right',
          className: 'pr30',
          // sortable: 'custom',
        }
        if (v.authname.length >= 5 && v.authname.length < 8) {
          o.width = 150
        } else if (v.authname.length >= 8) {
          o.width = 200
        } else {
          o.width = 120
        }
        // 与固定费用配置页的不可编辑项同步
        if ([1, 2, 3, 4].includes(v.id)) {
          arr1.push(o)
          this.mformCtrl1.push({
            label: v.authname,
            keyName: v.enname,
            err: `请填写${v.authname}`,
            type: "text",
            unit: '元',
          })
        } else if (['车辆违章', '违章罚款', '车辆年检'].includes(v.authname)) {
          arr2.push(o)
          // 取消快捷录入
          // this.mformCtrl.push({
          //   label: v.authname,
          //   keyName: v.enname,
          //   err: `请填写${v.authname}`,
          //   type: "text",
          //   unit: '元',
          // })
        } else {
          arr.push(o)
          this.mformCtrl.push({
            label: v.authname,
            keyName: v.enname,
            err: `请填写${v.authname}`,
            type: "text",
            unit: '元',
          })
        }
      })
      this.cols.push(...arr)
      this.cols.push(...arr2)
      this.cols.push(...arr1)
      this.cols.push(
        {
          keyName: "total", label: "费用合计", align: 'right', className: 'pr30', minwidth: 110,
          // sortable: 'custom'
        },
      )
      this.doLayout()
      this.getTotalProperty = [
        ...arr1.map(v => v.keyName),
        ...arr2.map(v => v.keyName),
        ...arr.map(v => v.keyName),
        'total',
      ]
      // console.log(this.cols)
      // console.log(this.getTotalProperty)
      this.$forceUpdate()
      if (Object.keys(this.$route.query).length) {
        this.setQueryParams()
        this.$nextTick(this.getList)
      } else {
        this.getList()
      }
    },
    setModalData(data) {
      const arr = [...this.mformCtrl, ...this.mformCtrl1]
      arr.map(v => {
        const key = v.keyName
        this.mform[key] = data[key]
      })
      this.mform.id = data.id
      // this.mform.orderid = data.orderid
    },
    onModalSubmit() {
      console.log({ ...this.mform })
      let url = `${this.baseUrl}/addedu`
      const params = {
        ...this.mform,
      }
      this.loading = true
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
    getItem(id) {
      const url = `fixedpaydetail/item`
      const params = { id }
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          // console.log(data)
          const { fixedauth } = data
          if (fixedauth && fixedauth.length) {
            this.mform1Ctrl.map(v => {
              if (v.keyName === 'fixedauth') {
                const arr = []
                fixedauth.map(c => {
                  if (!['车辆违章', '违章罚款', '车辆年检'].includes(c.authname)) {
                    arr.push({
                      label: c.authname,
                      value: c.enname,
                    })
                  }
                })
                v.options = arr
              }
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    onModal1Change({ key, value }) {
      // console.log(key, value)
      // console.log(key === 'money')
      if (['voucher'].includes(key)) {
        this.mform1[key] = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
      } else {
        // this.mform[key] = value;
        this.$set(this.mform1, key, value)
      }
      // console.log({ ...this.mform1 })
    },
    onModal1Submit() {
      console.log({ ...this.mform1 })
      let url = `fixedpaydetail/addedu`
      const params = {
        ...this.mform1,
        userid: this.user.id,
      }
      this.loading = true
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog('dialog1')
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    this.MONTH = this.CURR_MONTH
    this.$set(this.formInline, 'month', this.CURR_MONTH)

    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(1, 1)
      this.baseParams.push('fleet')
      this.getList()

      this.btns.splice(0, 2)
    }
  },
  mounted() {
    this.getOptions()
  },
};
</script>

<style lang="less" scoped>
.main {
  /deep/ .dialog {
    .el-dialog {
      width: 560px;

      .modal-scroll {
        height: auto;
        min-height: 300px;

        .el-scrollbar__wrap {
          overflow-x: hidden;
        }

        .is-horizontal {
          display: none;
        }
      }
    }

    .btns {
      margin: 0;
      text-align: center;
    }
  }
}

/deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
  margin-right: 0px;
  padding-right: 80px;
  position: relative;

  &::after {
    position: absolute;
    content: "";
    right: 40px;
    top: 6px;
    width: 1px;
    height: 28px;
    overflow: hidden;
    background-color: #EBEDF0;
  }
}
</style>
